"use client";

import { Box } from "@mantine/core";
import { useTranslation } from "react-i18next";

import SoundSlider from "@/components/general/sound-slider/sound-slider";
import { useStateContext } from "@/context/context-provider";

import cardStyles from "../general/card/card.module.css";
import { Section } from "../general/section";
import { SectionTitle } from "../general/section-title/section-title";
import { EscapeRoomProps } from "../types";
import styles from "./escape-room-details.module.css";
import { InteractionInstructions } from "./interaction-instructions/interaction-instructions";
import MultiplayerLobby from "./multiplayer-lobby/multiplayer-lobby";
import RoomDisplay from "./room-display/room-display";

const EscapeRoomDetails = ({ room }: { room: EscapeRoomProps }) => {
    const { isMobile } = useStateContext();
    const { t } = useTranslation();

    return (
        <Section variant="purple-cyan">
            <SectionTitle title={room.title} subTitle="ESCAPE ROOM" isH1 />

            <div className={styles.escapeRoomDetails}>
                <RoomDisplay room={room} />
                {!isMobile && (
                    <div className={styles.rightContent}>
                        <MultiplayerLobby roomUrl={room.url} id={room.id} price={room.price} />
                        <InteractionInstructions />
                        <Box className={`${cardStyles.card} ${styles.soundSettings}`}>
                            <label className="description">{t("menu.volume")}</label>
                            <SoundSlider />
                            <label className="description">{t("menu.backgroundMusic")}</label>
                            <SoundSlider soundSetting="background" />
                        </Box>
                    </div>
                )}
            </div>
        </Section>
    );
};
export default EscapeRoomDetails;
